<template>
  <div class="dashboard">
    <div class="row m-b-sm" v-if="user.category === 2 || user.role === 3">
      <div class="col-xs-12">
        <span class="bold">所在部门：</span>
        <select v-model="parent.selected" class="select input-sm m-r-xs" v-for="(parent,indexd) in pids" @change="selectParent($event,indexd)" :key="indexd">
          <option :value="p._id" v-for="p in parent.options" :key="p._id">{{p.name}}</option>
        </select>
        <button type="button" @click="query" class="btn-sm btn btn-info">查询</button>
      </div>
    </div>
    <div class="row">
      <div class="col-xs-12">
        <div class="panel">
          <div class="panel-title bg-success color-white">数据概览</div>
          <div class="panel-body">
            <div class="row">
              <div class="col-xs-12 col-sm-6 card">
                <div class="row">
                  <div class="col-xs-12 title">数据总量</div>
                </div>
                <div class="row">
                  <div class="col-xs-6 ">
                    <div class="number">{{summary.inviteTotal}}</div>
                    <div class="sub-title">邀请</div>
                  </div>
                  <div class="col-xs-6">
                    <div class="number">{{summary.reportTotal}}</div>
                    <div class="sub-title">报告</div>
                  </div>
                </div>
              </div>
              <div class="col-xs-12 col-sm-6 card">
                <div class="row">
                  <div class="col-xs-12  title">每日新增</div>
                </div>
                <div class="row">
                  <div class="col-xs-6">
                    <div class="number">{{summary.inviteYesterday}}</div>
                    <div class="sub-title">邀请</div>
                  </div>
                  <div class="col-xs-6">
                    <div class="number">{{summary.reportYesterday}}</div>
                    <div class="sub-title">报告</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-xs-12">
        <div class="panel">
          <div class="panel-title bg-warning color-white">每日趋势</div>
          <div class="panel-body">
            <div class="row">
              <div class="col-xs-12 m-t-b-xs">
                <div class="row">
                  <div class="col-sm-4 col-xs-12 input-sm text-right" style="line-height:30px;">
                    <a href="javascript:;" @click="last(7,daily)" class="color-info m-r-sm">最近7天</a>
                    <a href="javascript:;" @click="last(30,daily)" class="color-info">最近30天</a>
                  </div>
                  <div class="col-sm-8 col-xs-12">
                    <div class="row">
                      <div class="col-xs-9 col-sm-4">
                        <input class="input input-sm" type="text" @click="openByDrop($event,daily)" :value="daily.display" readonly>
                        <transition name="fade">
                          <div class="calendar-dropdown" :style="{'left':daily.left+'px','top':daily.top+'px'}" v-if="daily.show">
                            <calendar :range="daily.range" :zero="daily.zero" :lunar="daily.lunar" :value="daily.value" :begin="daily.begin" :end="daily.end" @select="daily.select" @rangeStart="daily.rangeStart"></calendar>
                          </div>
                        </transition>
                      </div>
                      <div class="col-xs-3 col-sm-2 n-p-l">
                        <div class="btn btn-info btn-sm" @click="buildDailyLine">查询</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-xs-12">
                <div class="row" style="height:350px;" id="daily-trend-line-charts">
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-xs-12">
        <div class="panel">
          <div class="panel-title bg-danger color-white">能力群分布</div>
          <div class="panel-body">
            <div class="row">
              <div class="col-xs-12 m-t-b-xs">
                <div class="row">
                  <div class="col-sm-6 col-xs-12 text-right">
                    <div class="row">
                      <div class="col-sm-8 col-xs-12 n-p-r">
                        <select name="" v-model="ability.post" class="select input-sm" @change="buildAbilityBar">
                          <option value="-1">全部岗位</option>
                          <option :value="post._id" v-for="post in posts" :key="post._id">{{post.name}}</option>
                        </select>
                      </div>
                      <div class="col-sm-4 col-xs-12 input-sm n-p-r" style="line-height:30px;">
                        <a href="javascript:;" @click="last(7,ability)" class="color-info m-r-sm">最近7天</a>
                        <a href="javascript:;" @click="last(30,ability)" class="color-info">最近30天</a>
                      </div>
                    </div>
                  </div>
                  <div class="col-sm-6 col-xs-12">
                    <div class="row">
                      <div class="col-xs-9 col-sm-5">
                        <input class="input input-sm" type="text" @click="openByDrop($event,ability)" :value="ability.display" readonly>
                        <transition name="fade">
                          <div class="calendar-dropdown" :style="{'left':ability.left+'px','top':ability.top+'px'}" v-if="ability.show">
                            <calendar :range="ability.range" :zero="ability.zero" :lunar="ability.lunar" :value="ability.value" :begin="ability.begin" :end="ability.end" @select="ability.select" @rangeStart="ability.rangeStart"></calendar>
                          </div>
                        </transition>
                      </div>
                      <div class="col-xs-3 col-sm-2 n-p-l">
                        <div class="btn btn-info btn-sm" @click="buildAbilityBar">查询</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-xs-12">
                <div class="row m-b-sm" style="height:350px;" id="ability-bar-charts">
                </div>
                <div class="row" style="height:350px;" id="ability-radar-charts" v-show="ability.length >= 3">
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-xs-12">
        <div class="panel">
          <div class="panel-title bg-success color-white">详细数据</div>
          <div class="panel-body">
            <div class="row">
              <div class="col-xs-12 m-t-b-xs">
                <div class="row">
                  <div class="col-sm-6 col-xs-12 text-right">
                    <div class="row">
                      <div class="col-sm-8 col-xs-12 n-p-r">
                        <select name="" v-model="detail.post" class="select input-sm" @change="detailPostChange">
                          <option value="-1">全部岗位</option>
                          <option :value="post._id" v-for="post in posts" :key="post._id">{{post.name}}</option>
                        </select>
                      </div>
                      <div class="col-sm-4 col-xs-12 input-sm n-p-r" style="line-height:30px;">
                        <a href="javascript:;" @click="last(7,detail)" class="color-info m-r-sm">最近7天</a>
                        <a href="javascript:;" @click="last(30,detail)" class="color-info">最近30天</a>
                      </div>
                    </div>
                  </div>
                  <div class="col-sm-6 col-xs-12">
                    <div class="row">
                      <div class="col-xs-9 col-sm-5">
                        <input class="input input-sm" type="text" @click="openByDrop($event,detail)" :value="detail.display" readonly>
                        <transition name="fade">
                          <div class="calendar-dropdown" :style="{'left':detail.left+'px','top':detail.top+'px'}" v-if="detail.show">
                            <calendar :range="detail.range" :zero="detail.zero" :lunar="detail.lunar" :value="detail.value" :begin="detail.begin" :end="detail.end" @select="detail.select" @rangeStart="detail.rangeStart"></calendar>
                          </div>
                        </transition>
                      </div>
                      <div class="col-xs-3 col-sm-2 n-p-l">
                        <div class="btn btn-info btn-sm" @click="buildDetail">查询</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-xs-12" v-if="detail.post !== '-1'">
                <div class="row" v-for="ability in detail.abilities" :key="ability._id">
                  <div class="col-xs-12 col-sm-2 text-right" style="height:50px;line-height:50px;">
                    {{ability.name}}
                  </div>
                  <div class="col-xs-12 col-sm-8">
                    <range-slider class="row" v-model="ability.range" :max="ability.max" :min="ability.min" :type="ability.type" :name="ability.name" :id="ability._id" @change="detail.rangeChange"></range-slider>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-xs-12">
                  <table class="table table-border" style="table-layout:fixed">
                    <thead>
                      <tr>
                        <th style="width:32px;">序号</th>
                        <th>姓名</th>
                        <th>联系方式</th>
                        <th v-if="detail.post === '-1'">岗位</th>
                        <th class="sort-th" @click="sort(1)" style="cursor:pointer;">
                          <span class="sort">
                            <i class="fa" :class="{'fa-angle-up':detail.score_sort != 1,'fa-caret-up': detail.score_sort === 1}"></i>
                            <i class="fa" :class="{'fa-angle-down':detail.score_sort != -1,'fa-caret-down': detail.score_sort === -1}"></i>
                          </span>
                          综合得分</th>
                        <th class="sort-th" v-for="(ability,k1) in detail.view_abilities" :key="k1" @click="sort(ability,detail.view_abilities)" style="cursor:pointer;">
                          <span class="sort">
                            <i class="fa" :class="{'fa-angle-up':ability.sort != 1,'fa-caret-up': ability.sort === 1}"></i>
                            <i class="fa" :class="{'fa-angle-down':ability.sort != -1,'fa-caret-down': ability.sort === -1}"></i>
                          </span>{{ability.name}}
                        </th>
                        <th style="width:100px;">操作</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(report,ind) in detail.view_reports" :key="report._id">
                        <td>{{detail.start+ind+1}}</td>
                        <td>{{report.name}}</td>
                        <td>{{report.phone||report.email}}</td>
                        <td v-if="detail.post === '-1'">{{report.questionnaire.name}}</td>
                        <td>{{report.abilities_score.toFixed(2)}}</td>
                        <td v-for="(ability,k1) in detail.view_abilities" :key="k1">
                          {{report.show_abilities[k1]?report.show_abilities[k1].score.toFixed(2) : '-'}}
                        </td>
                        <td>
                          <router-link :to="{'name': 'EvaluateReport',params: {'code':report._id}}" class="btn  btn-primary btn-xs" target="_blank">报告</router-link>
                          <a href="javascript:;" class="btn btn-xs btn-info" @click="addCompareResume(report)" v-if="selectPost=== '-1'||selectPost=== report.questionnaire._id">对比</a>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                  <div class="col-xs-12">
                    <pagination :current="detail.current" :length="20" :total="detail.reports.length" :page-click="go"></pagination>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import { deepCopy } from "../../plugins/utils";
import Post from "../../resource/post";
import Organization from "../../resource/organization";
import Calendar from "../blocks/calendar.vue";
import RangeSlider from "../blocks/range-slider";
import Echarts from "echarts/lib/echarts.js";
import "echarts/lib/chart/radar.js";
import "echarts/lib/chart/bar.js";
import "echarts/lib/chart/line.js";
import "echarts/lib/component/title";
import "echarts/lib/component/tooltip";
import "echarts/lib/component/legend";
import Toaster from "../../plugins/toaster.js";
export default {
  data: function() {
    return {
      orgs: [],
      view_orgs: {},
      summary: {
        inviteTotal: 0,
        inviteYesterday: 0,
        reportTotal: 0,
        reportYesterday: 0
      },
      daily: {
        display: "",
        show: false,
        range: true,
        zero: true, // zeropad
        value: [[2018, 2, 16], [2019, 2, 16]], //默认日期
        begin: [],
        end: [],
        lunar: false, //显示农历
        select: (begin, end) => {
          this.daily.show = false;
          this.daily.value = [begin, end];
          this.daily.display = begin.join("-") + " ~ " + end.join("-");
          this.daily.begin = [];
        },
        rangeStart: start => {
          let d = new Date(...start);
          let duration = 60;
          let length = Math.floor((duration - 1) / 2);
          d.setDate(d.getDate() - length);
          this.daily.begin = [d.getFullYear(), d.getMonth() + 1, d.getDate()];
          d.setDate(d.getDate() + duration);
          let end = [d.getFullYear(), d.getMonth() + 1, d.getDate()];
          let te = parseInt(
            [end[0], this.zeroPad(end[1]), this.zeroPad(end[2])].join("")
          );
          if (te > this.yesterday) {
            end = this.yesterday_end;
          }
          this.daily.end = end;
        },
        chart: null,
        load: () => {
          this.buildDailyLine();
        }
      },
      ability: {
        post: "-1",
        display: "",
        show: false,
        range: true,
        zero: true, // zeropad
        value: [[2018, 2, 16], [2019, 2, 16]], //默认日期
        begin: [],
        end: [],
        lunar: false, //显示农历
        select: (begin, end) => {
          this.ability.show = false;
          this.ability.value = [begin, end];
          this.ability.display = begin.join("-") + " ~ " + end.join("-");
          this.ability.begin = [];
        },
        rangeStart: start => {
          let d = new Date(...start);
          let duration = 60;
          let length = Math.floor((duration - 1) / 2);
          d.setDate(d.getDate() - length);
          this.ability.begin = [d.getFullYear(), d.getMonth() + 1, d.getDate()];
          d.setDate(d.getDate() + duration);
          let end = [d.getFullYear(), d.getMonth() + 1, d.getDate()];
          let te = parseInt(
            [end[0], this.zeroPad(end[1]), this.zeroPad(end[2])].join("")
          );
          if (te > this.yesterday) {
            end = this.yesterday_end;
          }
          this.ability.end = end;
        },
        chart: null,
        radar: null,
        length: 0,
        load: () => {
          this.buildAbilityBar();
        }
      },
      detail: {
        score_sort: 1,
        post: "-1",
        display: "",
        show: false,
        range: true,
        zero: true, // zeropad
        value: [[2018, 2, 16], [2019, 2, 16]], //默认日期
        begin: [],
        end: [],
        lunar: false, //显示农历
        select: (begin, end) => {
          this.detail.show = false;
          this.detail.value = [begin, end];
          this.detail.display = begin.join("-") + " ~ " + end.join("-");
          this.detail.begin = [];
        },
        rangeStart: start => {
          let d = new Date(...start);
          let duration = 60;
          let length = Math.floor((duration - 1) / 2);
          d.setDate(d.getDate() - length);
          this.detail.begin = [d.getFullYear(), d.getMonth() + 1, d.getDate()];
          d.setDate(d.getDate() + duration);
          let end = [d.getFullYear(), d.getMonth() + 1, d.getDate()];
          let te = parseInt(
            [end[0], this.zeroPad(end[1]), this.zeroPad(end[2])].join("")
          );
          if (te > this.yesterday) {
            end = this.yesterday_end;
          }
          this.detail.end = end;
        },
        chart: null,
        load: () => {
          this.detailPostChange();
        },
        current: 1,
        start: 0,
        abilities: [],
        reports: [],
        view_reports: [],
        view_abilities: {},
        rangeChange: (id, range) => {
          let ability = this.detail.view_abilities[id];
          if (ability) {
            ability.range = range;
          }
        }
      },
      is_mounted: false,
      yesterday: 0,
      yesterday_end: [],
      posts: [],
      view_posts: {},
      view_abilities: {},
      cache: {},
      company: "",
      hr: "",
      organization: "",
      pids: [
        {
          selected: "-1",
          options: [{ _id: "-1", name: "请选择..." }]
        }
      ]
    };
  },
  computed: {
    // 就算属性
    ...mapGetters({
      user: "loginUser",
      selectPost: "selectPost"
    })
  },
  components: { Calendar, RangeSlider },
  created() {
    const that = this;
    if (
      that.user &&
      (that.user.category === 2 || that.user.role === 2 || that.user.role === 3)
    ) {
      if (that.user.category === 2) {
        that.company = that.user.user_company._id;
        that.hr = that.$route.params.hr || "";
      }
      if (that.user.role === 2 || that.user.role === 3) {
        that.company = that.user.company._id;
        that.hr = that.user._id;
      }
      if (that.user.category === 2 || that.user.role === 3) {
        that.loadOrgs();
      }
      that.load();
    }
  },
  methods: {
    load() {
      const that = this;
      let d = new Date();
      d.setDate(d.getDate() - 1);
      let end = [d.getFullYear(), d.getMonth() + 1, d.getDate()];
      that.yesterday = parseInt(
        [end[0], that.zeroPad(end[1]), that.zeroPad(end[2])].join("")
      );
      that.yesterday_end = end;
      that.daily.end = end;
      that.daily.begin = []; // 开始日期
      that.ability.begin = []; // 开始日期
      that.ability.end = that.detail.begin = []; // 开始日期
      that.detail.end = end;
      that.loadDashboard();
      that.loadPosts();
      that.last(60, that.daily);
      that.last(60, that.ability);
      setTimeout(function() {
        that.last(60, that.detail, 0);
      }, 3000);
    },
    query() {
      const that = this;
      that.organization = "";
      that.pids.forEach(p => {
        if (p.selected != -1) {
          that.organization = p.selected;
        }
      });
      that.load();
    },
    loadOrgs() {
      const that = this;
      Organization.query({}).then(
        res => {
          let data = res.body;
          if (data.code === 0) {
            let orgs = data.result || [];
            let _orgs = [];
            that.view_orgs = {};
            orgs.forEach(org => {
              // 自身检查
              let tmp = that.view_orgs[org._id];
              if (!tmp) {
                // 不存在
                tmp = org;
                tmp.children = [];
                tmp.is_opened = 1;
                tmp.is_locked = -1;
                that.view_orgs[org._id] = tmp; // 设置
              } else {
                // 存在
                tmp.name = org.name;
                tmp.pid = org.pid;
                tmp.sort = org.sort;
              }
              if (tmp.pid) {
                //父级检查
                let p = that.view_orgs[org.pid];
                if (!p) {
                  // 不存在
                  p = {
                    _id: org.pid,
                    children: [],
                    is_opened: 1,
                    is_locked: -1
                  };
                  that.view_orgs[org._id] = p; // 设置
                }
                p.children.push(tmp);
              } else {
                _orgs.push(tmp);
              }
            });
            let sort = function(ogs) {
              ogs.sort((a, b) => {
                return a.sort - b.sort;
              });
              ogs.forEach(og => sort(og.children));
            };
            sort(_orgs);
            that.orgs = _orgs;
            that.pids = [
              {
                selected: "-1",
                options: [{ _id: "-1", name: "请选择..." }].concat(that.orgs)
              }
            ];
          } else {
            Toast.alert(data.msg);
          }
        },
        res => {}
      );
    },
    selectParent(event, indexd) {
      const that = this;
      let val = event.target.value;
      that.pids = that.pids.slice(0, indexd + 1);
      if (val !== "-1") {
        // indexd
        let tmp = that.view_orgs[val];
        if (tmp) {
          if (tmp.children.length > 0) {
            that.pids.push({
              selected: "-1",
              options: [{ _id: "-1", name: "请选择..." }].concat(tmp.children)
            });
          }
        }
      }
    },
    // 日期补零
    zeroPad(n) {
      return String(n < 10 ? "0" + n : n);
    },
    openByDialog() {
      this.daily.show = true;
    },
    closeByDialog() {
      this.daily.show = false;
    },
    openByDrop(e, calendar) {
      calendar.show = true;
      calendar.left = e.target.offsetLeft;
      calendar.top = e.target.offsetTop + 35;

      e.stopPropagation();
      window.setTimeout(() => {
        document.addEventListener(
          "click",
          e => {
            calendar.show = false;
            document.removeEventListener("click", () => {}, false);
          },
          false
        );
      }, 1000);
    },
    last(days, calendar, offset) {
      const that = this;
      let d = new Date();
      if (!offset && offset !== 0) {
        offset = 1;
      }
      d.setDate(d.getDate() - offset);
      let end = [d.getFullYear(), d.getMonth() + 1, d.getDate()];
      d.setDate(d.getDate() - days + 1);
      let begin = [d.getFullYear(), d.getMonth() + 1, d.getDate()];
      calendar.value = [begin, end];
      calendar.display =
        [begin[0], that.zeroPad(begin[1]), that.zeroPad(begin[2])].join("-") +
        "~" +
        [end[0], that.zeroPad(end[1]), that.zeroPad(end[2])].join("-");
      calendar.load();
      return false;
    },
    loadDashboard() {
      const that = this;
      var query = {};
      query.company = that.company;
      query.organization = that.organization;
      query.hr = that.hr;
      that.$http
        .get("/api/v1/statistics/data_situation", { params: query }, {})
        .then(
          res => {
            let data = res.body;
            if (data.code === 0) {
              that.summary.inviteTotal = data.result.all_invitations;
              that.summary.inviteYesterday = data.result.add_invitations;
              that.summary.reportTotal = data.result.all_reports;
              that.summary.reportYesterday = data.result.add_reports;
            } else {
              Toaster.alert(data.errormsg);
            }
          },
          res => {}
        );
    },
    buildDailyLine: function() {
      const that = this;
      let query = {};
      let times = that.daily.display.split("~");
      query.start_time = times[0];
      query.end_time = times[1];
      query.company = that.company;
      query.organization = that.organization;
      query.hr = that.hr;
      that.$http
        .get("/api/v1/statistics/daily_trend", { params: query })
        .then(res => {
          let data = res.body;
          if (data.code == 0) {
            let trends = data.result;
            let options = {
              tooltip: {
                trigger: "axis",
                axisPointer: {
                  type: "cross",
                  label: {
                    backgroundColor: "#6a7985"
                  }
                }
              },
              legend: {
                data: ["每日新增邀请", "每日新增报告"],
                right: "1.5%"
              },
              grid: {
                left: "1.5%",
                right: "1.5%",
                bottom: "1.5%",
                containLabel: true
              },
              xAxis: {
                type: "category",
                data: []
              },
              yAxis: {
                type: "value",
                data: []
              },
              series: [
                {
                  name: "每日新增邀请",
                  type: "line",
                  label: {
                    normal: {
                      show: true,
                      position: "top"
                    }
                  },
                  data: []
                },
                {
                  name: "每日新增报告",
                  type: "line",
                  label: {
                    normal: {
                      show: true,
                      position: "top"
                    }
                  },
                  data: []
                }
              ]
            };
            trends.sort((a, b) => {
              let aDate = Number(a.date.replace(/-/gi, ""));
              let bDate = Number(b.date.replace(/-/gi, ""));
              return aDate - bDate;
            });
            trends.forEach(trend => {
              options.xAxis.data.push(trend.date);
              options.series[0].data.push(trend.invitations);
              options.series[1].data.push(trend.reports);
            });
            let timer = function() {
              if (that.is_mounted) {
                if (!that.daily.chart) {
                  that.daily.chart = Echarts.init(
                    document.querySelector("#daily-trend-line-charts")
                  );
                }
                that.daily.chart.setOption(options);
              } else {
                setTimeout(timer, 100);
              }
            };
            timer();
          } else {
            Toaster.alert(data.errormsg);
          }
        });
    },
    buildAbilityBar: function() {
      const that = this;
      let query = {};
      let times = that.ability.display.split("~");
      query.start_time = times[0];
      query.end_time = times[1];
      query.post = that.ability.post;
      query.company = that.company;
      query.organization = that.organization;
      query.hr = that.hr;
      that.ability.length = 0;
      that.loadAbilities(query, reports => {
        let abilities = {};
        reports.forEach(report => {
          report.abilities.forEach(ability => {
            // 能力群
            let tmp = abilities[ability.ability._id];
            if (!tmp) {
              tmp = {
                name: ability.ability.name, // 能力群名称，
                data: [0, 0, 0, 0], // 分段统计
                scores: 0,
                size: 0
              };
              abilities[ability.ability._id] = tmp;
            }
            tmp.scores += ability.score;
            tmp.size++;
            if (ability.score < 40) {
              tmp.data[0]++;
            } else if (ability.score < 60) {
              tmp.data[1]++;
            } else if (ability.score < 80) {
              tmp.data[2]++;
            } else {
              tmp.data[3]++;
            }
          });
        });
        let timer = function() {
          if (that.is_mounted) {
            if (!that.ability.chart) {
              that.ability.chart = Echarts.init(
                document.querySelector("#ability-bar-charts")
              );
            }
            let options = {
              tooltip: {
                trigger: "axis",
                axisPointer: {
                  type: "cross",
                  label: {
                    backgroundColor: "#6a7985"
                  }
                }
              },
              legend: {
                data: ["0~40", "40~60", "60~80", "80~100"],
                right: "1.5%"
              },
              grid: {
                left: "1.5%",
                right: "1.5%",
                bottom: "1.5%",
                containLabel: true
              },
              xAxis: [
                {
                  type: "value"
                }
              ],
              yAxis: {
                type: "category",
                axisLabel: {
                  textStyle: {
                    color: "#000000",
                    fontSize: 14,
                    fontWeight: "Bold"
                  }
                },
                data: []
              },
              series: [
                {
                  name: "0~40",
                  type: "bar",
                  stack: "总量",
                  label: {
                    normal: {
                      show: true,
                      position: "insideRight"
                    }
                  },
                  data: []
                },
                {
                  name: "40~60",
                  type: "bar",
                  stack: "总量",
                  label: {
                    normal: {
                      show: true,
                      position: "insideRight"
                    }
                  },
                  data: []
                },
                {
                  name: "60~80",
                  type: "bar",
                  stack: "总量",
                  label: {
                    normal: {
                      show: true,
                      position: "insideRight"
                    }
                  },
                  data: []
                },
                {
                  name: "80~100",
                  type: "bar",
                  stack: "总量",
                  label: {
                    normal: {
                      show: true,
                      position: "insideRight"
                    }
                  },
                  data: []
                }
              ]
            };
            let radarOptions = {
              title: {
                text: "能力群平均分"
              },
              tooltip: {
                trigger: "axis"
              },
              legend: {
                data: ["平均分"],
                orient: "vertical",
                right: "20px"
              },
              radar: {
                name: {
                  textStyle: {
                    color: "#000000",
                    fontSize: 16,
                    fontWeight: "Bold"
                  }
                },
                indicator: []
              },
              series: [
                {
                  name: "平均分",
                  type: "radar",
                  tooltip: {
                    trigger: "item"
                  },
                  itemStyle: {
                    normal: {
                      areaStyle: { type: "default" },
                      color: function(data) {
                        return "#00cc99";
                      }
                    }
                  },
                  data: [
                    {
                      value: [],
                      name: "平均分"
                    }
                  ]
                }
              ]
            };
            for (let p in abilities) {
              let d = abilities[p];
              options.yAxis.data.push(d.name);
              d.data.forEach((e, i) => {
                options.series[i].data.push(e);
              });
              that.ability.length++;
              radarOptions.radar.indicator.push({
                name: d.name,
                max: 100
              });
              radarOptions.series[0].data[0].value.push(
                parseFloat((d.scores / d.size).toFixed(2))
              );
            }
            that.ability.chart.setOption(options);
            if (that.ability.length >= 3) {
              setTimeout(() => {
                if (!that.ability.radar) {
                  that.ability.radar = Echarts.init(
                    document.querySelector("#ability-radar-charts")
                  );
                }
                that.ability.radar.setOption(radarOptions);
              }, 100);
            }
          } else {
            setTimeout(timer, 100);
          }
        };
        timer();
      });
    },
    detailPostChange: function() {
      const that = this;
      let abilities = [];
      let view_abilities = {};
      let post = that.view_posts[that.detail.post];
      if (post) {
        post.abilities.forEach(a => {
          let ab = {
            _id: a.ability._id,
            name: a.ability.name,
            range: [0, 100],
            min: 0,
            max: 100,
            type: "double",
            sort: 0
          };
          abilities.push(ab);
          view_abilities[a.ability._id] = ab;
        });
      } else {
        that.posts.forEach(tPost => {
          tPost.abilities.forEach(a => {
            let ab = {
              _id: a.ability._id,
              name: a.ability.name,
              range: [0, 100],
              min: 0,
              max: 100,
              sort: 0
            };
            abilities.push(ab);
            view_abilities[a.ability._id] = ab;
          });
        });
      }
      that.detail.abilities = abilities;
      that.detail.view_abilities = view_abilities;
      that.buildDetail();
    },
    buildDetail: function() {
      const that = this;
      let query = {};
      that.detail.current = 1;
      let times = that.detail.display.split("~");
      query.start_time = times[0];
      query.end_time = times[1];
      query.post = that.detail.post;
      that.loadAbilities(query, reports => {
        if (that.detail.post === "-1") {
          that.detail.reports = reports;
        } else {
          that.detail.reports = reports.filter(r => {
            let fs = [];
            r.abilities.forEach(a => {
              let score = a.score;
              let range = that.detail.view_abilities[a.ability._id].range;
              fs.push(score >= range[0] && score <= range[1] ? 1 : 0);
            });
            return fs.join("") === "1".repeat(fs.length);
          });
        }
        that.detail.score_sort = 1;
        that.sort(1);
      });
    },
    loadPosts: function() {
      const that = this;
      let query = {};
      query.company = that.company;
      query.organization = that.organization;
      query.hr = that.hr;
      that.$http.get("/api/v1/statistics/posts", { params: query }).then(
        res => {
          let data = res.body;
          if (data.code === 0) {
            that.posts = data.result || [];
            that.posts.forEach(p => {
              that.view_posts[p._id] = p;
            });
          } else {
            Toaster.alert(data.msg);
          }
        },
        res => {}
      );
    },
    loadAbilities: function(query, callback) {
      const that = this;
      let res = [];
      query.company = that.company;
      query.organization = that.organization;
      query.hr = that.hr;
      // let begin = Number(query.start_time.replace(/-/gi, ''))
      // let end = Number(query.end_time.replace(/-/gi, ''))
      // let post_tag = query.post === '-1' ? 'all' : query.post
      // let cache_key = `${begin}~${end}~${post_tag}`;
      // let tmp = that.cache[cache_key]; // 直接查询
      // if (!tmp) {
      //     let find = -1
      //     for (let p in that.cache) { //
      //         if (find === -1) {
      //             let times = p.split('~') // 拆分
      //             let tBegin = Number(times[0])
      //             let tEnd = Number(times[1])
      //             if (begin >= tBegin && end <= tEnd) { // 符合日期条件
      //                 if (post_tag === times[2]) { // 符合条件
      //                     res = that.cache[p].filter(f => (f.date >= begin && f.date <= end))
      //                     find = 1
      //                     break
      //                 } else {
      //                     if (times[2] === 'all') {
      //                         res = that.cache[p].filter(f => (f.questionnaire._id === post_tag && f.date >= begin && f.date <= end))
      //                         find = 1
      //                         break
      //                     }
      //                 }
      //                 if (find) {
      //                     that.cache[cache_key] = res
      //                 }
      //             }
      //         } else {
      //             break;
      //         }
      //     }
      // } else {
      //     res = tmp
      // }
      // if (res.length == 0) {
      if (query.post === "-1") {
        delete query.post;
      }
      if (Object.keys(that.view_abilities).length === 0) {
        query.withAbilities = 1;
      }
      that.$http
        .get("/api/v1/statistics/post_abilities", { params: query })
        .then(res => {
          let data = res.body;
          if (data.code === 0) {
            let reports = data.result.reports;
            let abilities = data.result.abilities;
            if (abilities.length > 0) {
              that.view_abilities = abilities.reduce((pre, val) => {
                pre[val._id] = val;
                return pre;
              }, {});
            }
            const view_abilities = that.view_abilities;
            reports.forEach(r => {
              // 处理数据
              let endTime = new Date(r.end_time);
              r.date = Number(
                endTime.getFullYear() +
                  that.zeroPad(endTime.getMonth() + 1) +
                  that.zeroPad(endTime.getDate())
              );
              r.show_abilities = {};
              let t = that.view_posts[r.questionnaire] || {
                _id: r.questionnaire
              };
              r.questionnaire = {
                _id: t._id,
                name: t.name
              };
              r.abilities.forEach(a => {
                a.ability = view_abilities[a.ability];
                r.show_abilities[a.ability._id] = {
                  _id: a.ability._id,
                  name: a.ability.name,
                  score: a.score
                };
              });
            });
            reports.sort((a, b) => a.date - b.date);
            // that.cache[cache_key] = reports
            callback(reports);
          } else {
            Toaster.alert(data.errormsg);
          }
        });
      // } else {
      //     callback(res)
      // }
    },
    sort: function(ability, abs) {
      const that = this;
      if (ability === 1) {
        // 综合得分
        let sort = 0;
        if (that.detail.score_sort === 0) {
          sort = 1;
        } else if (that.detail.score_sort === 1) {
          sort = -1;
        } else {
          sort = 1;
        }
        that.detail.score_sort = sort;
        that.detail.reports.sort((a, b) => {
          let x = Number(a.abilities_score || "0");
          let y = Number(b.abilities_score || "0");
          let sub = x - y;
          return (sub > 0 ? 1 : -1) * sort;
        });
      } else {
        // 能力群 排序
        that.detail.score_sort = 0;
        let sort = 0;
        if (ability.sort === 0) {
          sort = 1;
          for (let p in abs) {
            let a = abs[p];
            a && (a.sort = 0);
          }
        } else if (ability.sort === 1) {
          sort = -1;
        } else {
          sort = 1;
        }
        ability.sort = sort;
        that.detail.reports.sort((a, b) => {
          let x = Number((a.show_abilities[ability._id] || {}).score || "0");
          let y = Number((b.show_abilities[ability._id] || {}).score || "0");
          let sub = x - y;
          return (sub > 0 ? 1 : -1) * sort;
        });
      }
      that.go(1);
    },
    go: function(page) {
      const that = this;
      that.detail.current = page;
      that.detail.start = (page - 1) * 20;
      that.detail.view_reports = that.detail.reports.slice(
        that.detail.start,
        that.detail.start + 20
      );
    },
    addCompareResume: function(report) {
      const that = this;
      that.$store.dispatch("addCompareResume", {
        code: report._id,
        user: { realname: report.name, phone: report.phone },
        post: report.questionnaire.name,
        post_id: report.questionnaire._id,
        score: report.abilities_score.toFixed(2)
      });
    }
  },
  mounted() {
    const that = this;
    that.is_mounted = true;
  }
};
</script>
<style lang="less">
.fade-enter-active,
.fade-leave-active {
  transition: all 0.5s ease-in-out;
}

.fade-enter,
.fade-leave-active {
  opacity: 0;
  transform: translateY(-10px);
}

.calendar-dropdown {
  background: #fff;
  position: absolute;
  left: 0;
  top: 0;
  padding: 20px;
  border: 1px solid #ccc;
  border-radius: 2px;
  z-index: 999;
  &:before {
    position: absolute;
    left: 30px;
    top: -10px;
    content: "";
    border: 5px solid rgba(0, 0, 0, 0);
    border-bottom-color: #ccc;
  }

  &:after {
    position: absolute;
    left: 30px;
    top: -9px;
    content: "";
    border: 5px solid rgba(0, 0, 0, 0);
    border-bottom-color: #fff;
  }
}
</style>


// WEBPACK FOOTER //
// dashboard.vue?5bdb731f